import { Link } from "react-router-dom";
import { ArrowRight, Check, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PricingTier } from "./tiers";

interface PricingCardProps {
  tier: PricingTier;
  href: string;
  label: string;
}

export function PricingCard({ tier, href, label }: PricingCardProps) {
  const isHighlight = tier.highlighted;
  return (
    <div
      className={
        "relative flex flex-col rounded-3xl border bg-white p-7 transition-shadow " +
        (isHighlight
          ? "border-brand-500/70 shadow-xl shadow-brand-500/10 ring-1 ring-brand-500/40 lg:-translate-y-2"
          : "border-ink-200/70 hover:shadow-lg hover:shadow-ink-900/5")
      }
    >
      {isHighlight ? (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-brand-600 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-white shadow-md shadow-brand-600/30">
            <Star className="h-3 w-3 fill-current" />
            En Çok Tercih Edilen
          </span>
        </div>
      ) : null}

      <div className="mb-1 text-xs font-semibold uppercase tracking-[0.2em] text-ink-500">
        {tier.name}
      </div>
      <p className="min-h-[3rem] text-sm leading-relaxed text-ink-600">
        {tier.tagline}
      </p>

      <div className="mt-6 flex items-baseline gap-1.5">
        <span
          className={
            "text-4xl font-bold tracking-[-0.02em] " +
            (isHighlight ? "text-brand-700" : "text-ink-900")
          }
        >
          {tier.price}
        </span>
        {tier.priceSuffix ? (
          <span className="text-sm font-medium text-ink-500">
            {tier.priceSuffix}
          </span>
        ) : null}
      </div>
      <div className="mt-1 text-xs text-ink-500">{tier.priceNote}</div>

      <div className="my-6 h-px bg-ink-200/60" />

      <ul className="mb-8 flex-1 space-y-3">
        {tier.features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-ink-700">
            <Check
              className={
                "mt-0.5 h-4 w-4 shrink-0 " +
                (isHighlight ? "text-brand-600" : "text-ink-500")
              }
            />
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <Button
        asChild
        size="lg"
        variant={isHighlight ? "default" : "outline"}
        className="w-full gap-2"
      >
        <Link to={href}>
          {label}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </Button>
    </div>
  );
}

export function resolveTierCta(
  tier: PricingTier,
  isAuthed: boolean,
): { href: string; label: string } {
  if (tier.ctaHref === "/register" && isAuthed) {
    return { href: "/dashboard", label: "Uygulamaya Git" };
  }
  return { href: tier.ctaHref, label: tier.ctaLabel };
}
